export const authorityOptions = [
    { value: "SAT", label: "SAT" },
    { value: "PLD", label: "PLD" },
    { value: "FINANZAS", label: "FINANZAS" },
    { value: "IMSS", label: "IMSS" },
    { value: "INFONAVIT", label: "INFONAVIT" },
    { value: "STPS", label: "STPS" },
    { value: "ADUANA", label: "ADUANA" },
    { value: "COMERCIO EXTERIOR", label: "COMERCIO EXTERIOR" },
    { value: "POLICÍA FEDERAL", label: "POLICÍA FEDERAL" },
    { value: "Otras", label: "Otras" },
];